export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/b94cdee409f55382a26c8aa8c74f2625.png";